import React, { useState, useEffect } from 'react';
import useUploadBomReport from '../features/PpsiContainer/hooks/useUploadBomReport';
import FileUpload from 'components/nir/FileUpload';
import View from './views';

const UploadBomReportView = () => {
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState('');
  const [uploadBom, success, isUploading, error] = useUploadBomReport();
  const user = JSON.parse(localStorage.getItem('user'));

  useEffect(() => {
    if (success) {
      handleFileClear();
    }
  }, [success]);

  useEffect(() => {
    if (error) {
      handleFileClear();
    }
  }, [error]);

  const handleFileClear = () => {
    setFile(null);
    setFileName('');
  };

  const handleFileChange = event => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      event.target.value = '';
      setFile(selectedFile);
      setFileName(selectedFile.name);
    }
  };

  const handleUpload = () => {
    if (file) {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('userId', user.username);
      uploadBom(formData, fileName);
    }
  };
  View.UploadBomReportView.visit();
  return (
    <FileUpload
      file={file}
      fileName={fileName}
      onFileChange={handleFileChange}
      onUpload={handleUpload}
      onFileClear={handleFileClear}
      selectBtnText="Select excel file"
      uploadBtnText="Upload"
      isUploading={isUploading}
      acceptFileType=".xls,.xlsx"
      inputId="excel-upload-bom-report"
    />
  );
};

export default UploadBomReportView;
